import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../../api";
import { Package, Inbox, MailWarning, FileQuestion, ArrowRight } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Products", value: stats?.products, icon: Package, to: "/admin/products", color: "#0e7490" },
    { label: "Total RFQs", value: stats?.rfqs, icon: FileQuestion, to: "/admin/rfq", color: "#2e6f9e" },
    { label: "Unread RFQs", value: stats?.rfqs_unread, icon: MailWarning, to: "/admin/rfq", color: "#d9a441" },
    { label: "Messages", value: stats?.messages, icon: Inbox, to: "/admin/messages", color: "#3fa98a" },
  ];

  return (
    <div>
      <h1 className="font-display text-3xl text-[#0f1e33]">Dashboard</h1>
      <p className="text-[#5a6b7e] mt-1">Overview of your site content and enquiries.</p>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="group bg-white rounded-2xl border border-border p-6 hover:shadow-lg transition-shadow">
            <div className="flex items-center justify-between">
              <span className="h-11 w-11 rounded-xl flex items-center justify-center" style={{ background: `${c.color}18` }}>
                <c.icon style={{ color: c.color, width: 22, height: 22 }} />
              </span>
              <ArrowRight className="h-4 w-4 text-[#9aa8b5] group-hover:text-[#0e7490] transition-colors" />
            </div>
            <p className="mt-5 font-display text-4xl text-[#0f1e33]">{c.value ?? "—"}</p>
            <p className="text-sm text-[#5a6b7e] mt-1">{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 grid md:grid-cols-3 gap-5">
        <Link to="/admin/products" className="bg-white rounded-2xl border border-border p-6 hover:border-[#0e7490]/40 transition-colors">
          <Package className="h-6 w-6 text-[#0e7490]" />
          <h3 className="mt-4 font-display text-lg text-[#0f1e33]">Manage Products</h3>
          <p className="text-sm text-[#5a6b7e] mt-1.5">Add, edit or remove products and upload product images.</p>
        </Link>
        <Link to="/admin/content" className="bg-white rounded-2xl border border-border p-6 hover:border-[#0e7490]/40 transition-colors">
          <FileQuestion className="h-6 w-6 text-[#0e7490]" />
          <h3 className="mt-4 font-display text-lg text-[#0f1e33]">Edit Site Content</h3>
          <p className="text-sm text-[#5a6b7e] mt-1.5">Company info, stats, services, certifications, regions and more.</p>
        </Link>
        <Link to="/admin/rfq" className="bg-white rounded-2xl border border-border p-6 hover:border-[#0e7490]/40 transition-colors">
          <Inbox className="h-6 w-6 text-[#0e7490]" />
          <h3 className="mt-4 font-display text-lg text-[#0f1e33]">RFQ Enquiries &amp; Messages</h3>
          <p className="text-sm text-[#5a6b7e] mt-1.5">Review all RFQ submissions and contact messages.</p>
        </Link>
      </div>
    </div>
  );
}
